import { useQueries } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import { useOrgId } from 'hooks/index.js';
import { useFeatureContext } from 'contexts/FeatureContext.jsx';
import { useOngoingDubsContext } from 'contexts/OngoingDubsContext.jsx';

const useDubbingJobs = ({ broadcasts, onError, pollIntervalMs = 20000, context }) => {
  const firebase = useFirebase();
  const orgId = useOrgId();
  const { features } = useFeatureContext();
  const { dubbingShowsEnabled = false } = features;
  const { removeDubJob: removeDubJobFromOngoingContext, dubJobs: activeDubJobs } = context || useOngoingDubsContext();

  return useQueries(
    broadcasts
      .filter((broadcast) => !broadcast.id?.startsWith('mock-'))
      .map((broadcast) => ({
        enabled: dubbingShowsEnabled,
        queryKey: ['dubbingJobs', orgId, broadcast.id],
        queryFn: async () => {
          const agent = await firebase.getAgent();
          const params = { broadcastId: broadcast.id, jobType: 'dubbing' };
          const response = await agent.get(`/o/${orgId}/jobs`, params);

          const body = response?.body;
          for (const job of body) {
            if (
              activeDubJobs.some((dubJob) => dubJob.jid === job.jid)
              && (job.status === 'completed' || job.status === 'failed')
            ) {
              removeDubJobFromOngoingContext(job.jid, job.status);
            }
          }

          return body;
        },
        onError: (error, variables) => {
          console.log(error);
          onError(error, variables);
        },
        ...(broadcast.hasJobs && { refetchInterval: pollIntervalMs }),
      })),
  );
};

export default useDubbingJobs;
